import nrt_logo from '../../assets/images/nrt_logo.png'
import SidebarListBox from '../SidebarListBox'
import sidebar_image from '../../assets/images/sidebar_image.png'
import { Link } from 'react-router-dom'
import { useContext, useEffect, useState } from 'react'
import LoginContext from '../../context'

const Sidebar = () => {

    const { isAuthenticated, token } = useContext(LoginContext)
    const [unreadMessageCount, setUnreadMessageCount] = useState(0);

    useEffect(() => {
        if (!isAuthenticated) return;

        const fetchUnreadMessages = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/messages/unread-status`, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token?.token}`,
                    }
                })
                const data = await response.json()
                if (data.has_unread_messages) {
                    setUnreadMessageCount(data.unread_count)
                } else {
                    setUnreadMessageCount(0)
                }
            } catch (error) {
                console.error('Error checking unread messages:', error)
            }
        }

        fetchUnreadMessages()

        const interval = setInterval(fetchUnreadMessages, 30000)

        return () => clearInterval(interval)
    }, [isAuthenticated, token])

    const listItemsData1 = [
        {
            'icon_name': 'fi fi-rr-dice-alt',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': false,
            'link_name': '라이브카지노',
            'link_src': '/casino',
        },
        {
            'icon_name': 'fi fi-rr-slot-machine',
            'login_icon_name': 'fi fi-rr-dice-d10',
            'show_after_login': false,
            'acces_after_login': false,
            'link_name': '슬롯게임',
            'link_src': '/slot',
        },
        {
            'icon_name': 'fi fi-rr-gamepad',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': false,
            'link_name': ' 미니게임',
            'link_src': '/mini-games',
        },
        {
            'icon_name': 'fi fi-rr-donate',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 입금신청',
            'link_src': '/cash_1',
        },
        {
            'icon_name': 'fi fi-rr-arrow-down-to-square',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 출금신청',
            'link_src': '/cash_2',
        }
    ]
    const listItemsData2 = [
        {
            'icon_name': 'fi fi-rr-rectangle-list',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 배팅내역',
            'link_src': '/betting',
        },
        {
            'icon_name': 'fi fi-rr-trophy-star',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 경기결과',
            'link_src': '/result',
        },
        {
            'icon_name': 'fi fi-rr-gift',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 이벤트',
            'link_src': '/event',
        },
        {
            'icon_name': 'fi fi-rr-bullhorn',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 공지사항',
            'link_src': '/notice',
        },
        {
            'icon_name': 'fi fi-rr-headphones',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 고객센터',
            'link_src': '/customer',
        },
        {
            'icon_name': 'fi fi-rr-ticket',
            'login_icon_name': '',
            'show_after_login': true,
            'acces_after_login': true,
            'link_name': '  쿠폰함',
            'link_src': '/coupon',
        },
        {
            'icon_name': 'fi fi-rr-envelope',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': `쪽지함${isAuthenticated && unreadMessageCount > 0 ? ` (${unreadMessageCount})` : ''}`,
            'link_src': '/message',
        },
        {
            'icon_name': 'fi fi-rr-user-gear',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 마이페이지',
            'link_src': '#',
        },
        {
            'icon_name': 'fi fi-rr-calendar-check',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 출석부',
            'link_src': '#',
        },
        {
            'icon_name': 'fi fi-rr-user-add',
            'login_icon_name': '',
            'show_after_login': false,
            'acces_after_login': true,
            'link_name': ' 추천내역',
            'link_src': '/recommend_list',
        },
    ]
    return (
        <>
            <section className='sidebar hidden lg:block w-[300px] bg-obsidian fixed h-full'>
                <div className='pb-[50px] w-full h-full overflow-y-auto overflow-x-hidden no-scrollbar'>
                    <Link to='/' className='pt-5 block group'>
                        <img src={nrt_logo} alt="" className='w-[240px] mx-auto group-hover:filter group-hover:brightness-[1.5] transition-all duration-200 ease-in-out' />
                    </Link>
                    <div className=''>
                        <SidebarListBox listItems={listItemsData1} />
                        <SidebarListBox listItems={listItemsData2} />
                    </div>
                    <img src={sidebar_image} className='block my-2.5 mx-auto'></img>
                </div>
            </section>



        </>
    )
}

export default Sidebar